var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-card-image__container"},[(_vm.coverPhoto)?_c('img',{staticClass:"ci-card-image",attrs:{"src":_vm.imgSrc}}):_c('RdxIcon',{class:_vm.iconClasses}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }